import { Box } from "@mui/material";
import { ReactNode } from "react";

export function ListRowActions({
  actions,
  status
}: {
  actions?: ReactNode;
  status: ReactNode;
}) {
  return (
    <Box sx={{
      display: { xs: "contents", sm: "flex" },
      alignItems: "center",
      justifyContent: "flex-end",
      flexWrap: "wrap",
      gap: 1,
      minHeight: { xs: 0, sm: 40 },
      flexShrink: 0,
      "& .MuiButton-root": {
        minHeight: 40,
        whiteSpace: "nowrap"
      },
      "& .MuiChip-root": {
        height: { xs: 32, sm: 40 },
        whiteSpace: "nowrap"
      }
    }}>
      {actions}
      <Box className="mobile-card-status" sx={{
        display: "flex",
        alignItems: "center",
        position: { xs: "absolute", sm: "static" },
        top: { xs: 12, sm: "auto" },
        right: { xs: 16, sm: "auto" },
        zIndex: 1,
        maxWidth: { xs: "calc(100% - 72px)", sm: "none" }
      }}>
        {status}
      </Box>
    </Box>
  );
}
